// Member-card promotion fields on a product: discount text per card (e.g. 'ส่วนลด 15%') and its privilege remark.
// Clearing one of these in the backoffice must reach the API as '' (see keepEmpty in utils/form) — '' is how an
// admin removes a card's promotion from a single product.
export const CARD_PROMOTION_FIELDS = [
  'promotion_sale_price',
  'promotion_remark',
  'green_card_promotion_sale_price',
  'green_card_promotion_remark',
  'ev_card_promotion_sale_price',
  'ev_card_promotion_remark',
]
